<template>
  <columns>
    <column size="2">
      <logo/><br/>
      <p class="note">© 2006-2018, ООО «АРК-Эгергосбыт».<br/>Все права защищены</p>
      <a class="note" href="mailto:info@arkenergosbyt.ru">info@arkenergosbyt.ru</a>
    </column>
    <column size="2" :mobile="false">
      <router-link class="router-link" to="/about">О компании</router-link>
      <!--<router-link class="router-link" to="/news">Новости</router-link>-->
      <router-link class="router-link" to="/vacancies">Вакансии</router-link>
      <router-link class="router-link" to="/legal">Раскрытие информации</router-link>
      <router-link class="router-link" to="/contacts">Контакты</router-link>
      <router-link class="router-link" to="/profile">Личный кабинет</router-link>
    </column>
    <column size="2" :mobile="false">
      <router-link class="router-link" to="/power">Энергосбережение</router-link>
      <router-link class="router-link" to="/accounting">Системы учёта</router-link>
      <router-link class="router-link" to="/audit">Энергоаудит</router-link>
      <!--<router-link class="router-link" to="/regions">Сетевой комплекс</router-link>-->
      <router-link class="router-link" to="/consulting">Консалтинг</router-link>
      <router-link class="router-link" to="/trading">Энерготрейдинг</router-link>
    </column>
    <column size="4">
      <p>Адрес:</p>
      <heading type="h4" size="s">г. Москва, ул. Садовая-Кудринская д. 11, стр. 1</heading>
      <p><a href="tel:84957739215">8 (495) 773-92-15</a></p>
    </column>
  </columns>
</template>

<script>
import Heading from '@/components/Heading';
import Logo from '@/components/Logo';
import Columns from '@/components/columns/Columns';
import Column from '@/components/columns/Column';

export default {
  components: {
    Heading,
    Logo,
    Columns,
    Column,
  },
}
</script>



// WEBPACK FOOTER //
// FooterBar.vue?13bcc426